import { authFetch } from '@flexibilitypay/shared';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 */
export interface SaldoResponse {
  fecha: string;
  importe: number;
  moneda: string;
  linea: string;
  idCuenta: string;
}

export interface TitularExternal {
  tipoPersona: string;
  cuit: string;
  nombre: string;
}

export interface CuentaByCuit {
  cvu: string;
  alias: string;
  estado: string;
  nroCuentaEntidad: string;
  favorita: boolean;
  titulares: TitularExternal[];
  idCuenta?: string;
}

export interface UsuarioByCuitItem {
  usuario: string[];
  cuentas: CuentaByCuit[];
}

export type UsuarioByCuitResponse = UsuarioByCuitItem[];

export async function fetchSaldo(idCuenta: string): Promise<SaldoResponse> {
  const response = await authFetch(`/Saldos/${encodeURIComponent(idCuenta)}`);
  if (!response.ok) {
    throw new Error(`HTTP_${response.status}`);
  }
  return (await response.json()) as SaldoResponse;
}

export async function fetchUsuarioByCuit(cuit: string): Promise<UsuarioByCuitResponse> {
  const normalized = cuit.replace(/\D/g, '');
  const response = await authFetch(
    `/Usuarios/${encodeURIComponent(normalized)}/UsuarioByCuit`,
  );
  // 404 = CUIT sin cuentas en el tenant. Lo tratamos como resultado vacío
  // (no es error técnico) — la pantalla muestra empty state, no banner rojo.
  if (response.status === 404) {
    return [];
  }
  if (!response.ok) {
    throw new Error(`HTTP_${response.status}`);
  }
  return (await response.json()) as UsuarioByCuitResponse;
}
